import { Dialog } from '@progress/kendo-react-dialogs';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import { useState } from 'react';
import CashHistoryGrid from './CashHistoryGrid';
import CardChangeLogGrid from './CardChangeLogGrid';

type Props = {
  DriverID: number;
  DriverNumber: string;
  DriverName: string;
  CardNumber: string;
  CloseDialog: () => void;
};

const CardHistoryDialog = (props: Props) => {
  const [selected, setSelected] = useState(0);

  return (
    <Dialog title="Card History" onClose={props.CloseDialog}>
      <TabStrip selected={selected} onSelect={e => setSelected(e.selected)} keepTabsMounted={true}
        tabContentStyle={{ width: '100%' }} style={{ width: '100%' }} animation={false}>
        <TabStripTab title="Advance Cash History">
          <CashHistoryGrid DriverID={props.DriverID} IsGridInFocus={selected === 0} />
        </TabStripTab>
        <TabStripTab title="Transaction History">
          <CardChangeLogGrid DriverID={props.DriverID} IsGridInFocus={selected === 1} />
        </TabStripTab>
      </TabStrip>
    </Dialog>
  );
};

export default CardHistoryDialog;